import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import TemplateManage from '@/views/marketing/marketingManage/templateManage/index.vue'


const __default__ = { name: 'DcCosFbuTemplateManage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const permission = {
  add: 'fbu_tpl_add_btn',
  del: 'fbu_tpl_del_btn',
  edit: 'fbu_tpl_edit_btn'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TemplateManage, {
    subdomain: "fbu",
    permission: permission
  }))
}
}

})